export const CartItemTypes = Object.freeze({
    Course: 'course',
    Class: 'class',
    Plan: 'plan',
})
